export default __webpack_public_path__ + "static/media/homepage1.d3e9a40c.png";